export var loanOfferResponseMock = {
    requestId: '5e9d7966-66e6-442f-8afe-8db8faa1f73d',
    timestamp: '2024-07-18 12:02:37',
    type: 'LOAN_DETAILS',
    data: {
        offers: [
            {
                provider: 'liberis',
                preLimitId: 7272,
                offerId: '3172721',
                amount: 30000,
                currency: 'PLN',
                period: 6,
                pricing: 15.5,
                loanRepaymentPrice: 10.76,
                name: 'BCAD',
                createdAt: '2025-01-30 12:13:32',
                amountMin: 10000,
                amountMax: 30000,
            },
            {
                provider: 'liberis',
                preLimitId: 7272,
                offerId: '17272',
                amount: 30000,
                currency: 'PLN',
                period: 12,
                pricing: 17.5,
                loanRepaymentPrice: 11.76,
                name: 'KBCAG',
                createdAt: '2025-01-30 12:13:32',
                amountMin: 10000,
                amountMax: 30000,
            },
        ],
        limit: {
            id: 544,
            min: 2000,
            max: 50000,
            used: 0,
            available: 50000,
            currency: 'PLN',
            provider: 'liberis',
            minMaxDifference: true,
        },
    },
};
export var loanOfferNoOffersResponseMock = {
    requestId: '5e9d7966-66e6-442f-8afe-8db8faa1f73d',
    timestamp: '2024-07-18 12:02:37',
    type: 'LOAN_DETAILS',
    data: {
        offers: [],
        limit: {
            id: 544,
            min: 3000,
            max: 10000,
            used: 0,
            available: 10000,
            currency: 'PLN',
            provider: 'liberis',
            minMaxDifference: true,
        },
    },
};
